/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { aplicacaoRequest } from "./aplicacaoRequest";
import { DeleteOutlined } from "@ant-design/icons";
import { ModalDelete } from "../../../../Componentes/ModalDelete";
import { ModalStatusDelete } from "../../../../Utils/modalStatus";

export const Aplicacao = ({ id, tab }) => {
  const [aplicacao, setAplicacao] = useState([]);

  const [openDelete, setOpenDelete] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  const [idAplicacao, setIdAplicacao] = useState(null);

  const [loading, setLaoding] = useState(false);

  useEffect(() => {
    if (tab === 4) {
      getListaAplicacao();
    }
  }, [tab]);

  const getListaAplicacao = async () => {
    setLaoding(true);

    try {
      const response = await aplicacaoRequest.getAplicacao({ cartorio_id: id });
      if (response.status === 200 || response.status === 201) {
        const { results } = response.data;
        setAplicacao(results);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLaoding(false);
    }
  };

  const dataFormatada = (data) => {
    const date = new Date(data);
    const dateFormatted = date.toLocaleString().replace(",", "");
    return dateFormatted;
  };

  const columns = [
    { title: "Aplicação", dataIndex: "nome_aplicacao" },
    {
      title: "Data atualização",
      dataIndex: "data_hora_atualizacao",
      render: (value) => dataFormatada(value),
    },
    { title: "Intervalo atividade", dataIndex: "intervalo_atividade" },
    {
      title: "Status",
      dataIndex: "status",
      render: (value) => (
        <Tag color={value === "INATIVO" ? "red" : "green"}>{value}</Tag>
      ),
    },
    {
      title: "Ações",
      dataIndex: "acoes",
      render: (_, render) => (
        <DeleteOutlined
          style={{ cursor: "pointer" }}
          onClick={() => handleDelete(render.id)}
        />
      ),
    },
  ];

  const handleDelete = (value) => {
    setOpenDelete(true);
    setIdAplicacao(value);
  };

  const deleteAplicacao = async () => {
    try {
      const response = await aplicacaoRequest.deleteAplicacao(idAplicacao);

      if (response.status === 204) {
        getListaAplicacao();
        setOpenDelete(false);
        setOpenStatus(true);
        setIdAplicacao(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    setOpenDelete(false);
    setIdAplicacao(null);
  };

  return (
    <>
      <Table dataSource={aplicacao} columns={columns} loading={loading} />

      <ModalDelete
        message="Deseja realmente deletar este Aplicativo?"
        visible={openDelete}
        onCancel={handleCancel}
        onConfirm={deleteAplicacao}
      />

      <ModalStatusDelete
        onCancel={() => setOpenStatus(false)}
        visible={openStatus}
        message="Aplicativo deletado com sucesso!"
      />
    </>
  );
};
